import { render, staticRenderFns } from "./merchant-item-info.vue?vue&type=template&id=63f6f4b7&scoped=true&"
import script from "./merchant-item-info.vue?vue&type=script&lang=ts&"
export * from "./merchant-item-info.vue?vue&type=script&lang=ts&"
import style0 from "./merchant-item-info.vue?vue&type=style&index=0&id=63f6f4b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f6f4b7",
  null
  
)

export default component.exports